import { Svg, type SvgProps } from "./Svg";

export const RedArrow = ({
	height = "16",
	viewBox = "0 0 23 16",
	width = "23",
	xmlns = "http://www.w3.org/2000/svg",
	...rest
}: SvgProps) => {
	return (
		<Svg {...rest} {...{ height, viewBox, width, xmlns }}>
			<path
				d="M23 14.3927V7.74988C23 7.08559 22.6167 6.64274 22.0417 6.64274C21.4667 6.64274 21.0834 7.08559 21.0834 7.74988V11.7356L13.6084 3.09988C13.225 2.65702 12.65 2.65702 12.2667 3.09988L8.14586 7.86059L1.6292 0.332022C1.43753 0.110593 1.24586 -0.000121117 0.958364 -0.000121117C0.670864 -0.000121117 0.479197 0.110593 0.287531 0.332022C-0.0958028 0.774879 -0.0958028 1.43916 0.287531 1.88202L7.47503 10.1856C7.85836 10.6284 8.43336 10.6284 8.8167 10.1856L12.9375 5.42488L19.7417 13.2856H16.2917C15.7167 13.2856 15.3334 13.7284 15.3334 14.3927C15.3334 15.057 15.7167 15.4999 16.2917 15.4999H22.0417C22.1375 15.4999 22.3292 15.4999 22.425 15.3892C22.6167 15.2784 22.8084 15.057 22.9042 14.8356C23 14.7249 23 14.5034 23 14.3927Z"
				fill="#E62929"
			/>
		</Svg>
	);
};
